import spriteMap from './audioSpriteMap.json';

const spriteUrl = process.env.PUBLIC_URL + '/audio-sprite.mp3';

let currentAudio = null;

export default function speak(text) {
  const entry = spriteMap[text];
  if (!entry) return;

  // Stop any currently playing clip
  if (currentAudio) {
    currentAudio.pause();
    currentAudio = null;
  }

  // Create a fresh Audio element each time for reliable seeking
  const audio = new Audio(spriteUrl);
  currentAudio = audio;

  audio.currentTime = entry.start;
  audio.play().catch(() => {});

  // Use timeupdate to stop precisely at the end of this clip
  const endTime = entry.start + entry.duration;
  audio.addEventListener('timeupdate', () => {
    if (audio.currentTime >= endTime) {
      audio.pause();
      if (currentAudio === audio) currentAudio = null;
    }
  });
}
